import { isEmptyObject } from "@crema/utility/Utils";
import {
    ADD_INSTALLMENT,
    CREATE_CALL_LOGS,
    CREATE_FUND,
    CRM_REQUEST_LOGS,
    DELETE_CALL_LOGS_FILE,
    DELETE_FUNDS_INSTALLMENT_FILE,
    GET_CLIENT_DETAIL_ID,
    GET_CRM_FUND_PENDING,
    GET_MEMBER_LIST,
    GET_NONMEMBER_LIST,
    GET_SOCIALMEDIA_LIST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    UPDATE_CALL_LOGS,
    UPDATE_FUND,
    UPDATE_FUND_REQUEST_STATUS,
    UPDATE_INSTALLMENT,
    UPLOAD_EXCEL_FILE,
} from "shared/constants/ActionTypes";
const initialState = {
    loading: true,
    error: null,
    nonMemberClientList: [],
    socialClientList: [],
    memberClientList: [],
    clientDetailList: {},
    pendingApprovalList: [],
    requestLogs: [],
};
const handleFundClientDetail = (oldState, payload) => {
    let myOldState = { ...oldState };
    if (myOldState.crmFunds === null) {
        return {
            ...myOldState,
            crmFunds: [{ ...payload, crmFundsInstallments: [] }],
        };
    } else {
        return {
            ...myOldState,
            crmFunds: [
                { ...payload, crmFundsInstallments: [] },
                ...myOldState.crmFunds,
            ],
        };
    }
};
const handleCallClientDetail = (oldState, payload) => {
    let myOldState = { ...oldState };
    if (myOldState.callLogs === null) {
        return { ...myOldState, callLogs: [{ ...payload }] };
    } else {
        return {
            ...myOldState,
            callLogs: [{ ...payload }, ...myOldState.callLogs],
        };
    }
};
const addInstallmentHandler = (oldState, payload) => {
    let myOldState = { ...oldState };
    return {
        ...myOldState,
        crmFunds: [
            ...myOldState.crmFunds.map((item) => {
                if (item.id == payload.crmFundId) {
                    return {
                        ...item,
                        crmFundsInstallments: [
                            ...item.crmFundsInstallments,
                            { ...payload },
                        ],
                    };
                } else {
                    return item;
                }
            }),
        ],
    };
};
const updateInstallmentHandler = (oldState, payload) => {
    let myOldState = { ...oldState };
    return {
        ...myOldState,
        crmFunds: [
            ...myOldState.crmFunds.map((item) => {
                if (item.id == payload.crmFundId) {
                    return {
                        ...item,
                        crmFundsInstallments: [
                            ...item.crmFundsInstallments.map((itemList) =>
                                itemList.id == payload.id
                                    ? { ...payload }
                                    : itemList
                            ),
                        ],
                    };
                } else {
                    return item;
                }
            }),
        ],
    };
};
const updateInstallmentStatusRequest = (oldState, payload) => {
    let myOldState = { ...oldState };
    return {
        ...myOldState,
        crmFunds: [
            ...myOldState.crmFunds.map((item) => {
                if (item.tnxNo == payload.tnxId) {
                    return {
                        ...item,
                        crmFundsInstallments: [
                            ...item.crmFundsInstallments.map((itemList) =>
                                itemList.id == payload.id
                                    ? { ...payload }
                                    : itemList
                            ),
                        ],
                    };
                } else {
                    return item;
                }
            }),
        ],
    };
};
const deleteFundsInstallmentFile = (oldState, payload) => {
    let myOldState = { ...oldState };
    return {
        ...myOldState,
        crmFunds: [
            ...myOldState.crmFunds.map((item) => {
                if (item.id == payload.crmFundId) {
                    return {
                        ...item,
                        crmFundsInstallments: item.crmFundsInstallments.map(
                            (itemList) => {
                                if (itemList.id == payload.rowId) {
                                    return {
                                        ...itemList,
                                        crmFundsAttFile:
                                            itemList.crmFundsAttFile.filter(
                                                (lastItem) =>
                                                    lastItem.id != payload.id
                                            ),
                                    };
                                } else {
                                    return itemList;
                                }
                            }
                        ),
                    };
                } else {
                    return item;
                }
            }),
        ],
    };
};
export const crmReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true };
        case FETCH_SUCCESS:
            return { ...state, loading: false };
        case FETCH_ERROR:
            return { ...state, error: action.payload, loading: false };
        case GET_NONMEMBER_LIST:
            return {
                ...state,
                nonMemberClientList: action.payload,
            };
        case GET_SOCIALMEDIA_LIST:
            return {
                ...state,
                socialClientList: action.payload,
            };
        case UPLOAD_EXCEL_FILE:
            return {
                ...state,
                socialClientList: action.payload,
            };
        case GET_MEMBER_LIST:
            return {
                ...state,
                memberClientList: action.payload,
            };
        case GET_CLIENT_DETAIL_ID:
            return {
                ...state,
                clientDetailList: action.payload,
            };
        case CREATE_CALL_LOGS:
            return {
                ...state,
                clientDetailList: handleCallClientDetail(
                    state.clientDetailList,
                    action.payload
                ),
            };
        case UPDATE_CALL_LOGS:
            return {
                ...state,
                clientDetailList: {
                    ...state.clientDetailList,
                    callLogs: [
                        ...state.clientDetailList.callLogs.map((item) =>
                            item.id == action.payload.id
                                ? { ...action.payload }
                                : item
                        ),
                    ],
                },
            };

        case DELETE_CALL_LOGS_FILE:
            return {
                ...state,
                clientDetailList: {
                    ...state.clientDetailList,
                    callLogs: [
                        ...state.clientDetailList.callLogs.map((item) =>
                            item.id == action.payload.rowId
                                ? {
                                      ...item,
                                      crmCallAttFile:
                                          item.crmCallAttFile.filter(
                                              (listItem) =>
                                                  action.payload.id !=
                                                  listItem.id
                                          ),
                                  }
                                : item
                        ),
                    ],
                },
            };
        case CREATE_FUND:
            return {
                ...state,
                clientDetailList: handleFundClientDetail(
                    state.clientDetailList,
                    action.payload
                ),
            };
        case UPDATE_FUND:
            return {
                ...state,
                clientDetailList: {
                    ...state.clientDetailList,
                    crmFunds: [
                        ...state.clientDetailList.crmFunds.map((item) =>
                            item.id == action.payload.id
                                ? { ...action.payload }
                                : item
                        ),
                    ],
                },
            };
        case ADD_INSTALLMENT:
            return {
                ...state,
                clientDetailList: addInstallmentHandler(
                    state.clientDetailList,
                    action.payload
                ),
            };
        case UPDATE_INSTALLMENT:
            return {
                ...state,
                clientDetailList: updateInstallmentHandler(
                    state.clientDetailList,
                    action.payload
                ),
            };
        case UPDATE_FUND_REQUEST_STATUS:
            return {
                ...state,
                pendingApprovalList: state.pendingApprovalList.filter(
                    (item) => item.id != action.payload.id
                ),
                clientDetailList: !isEmptyObject(state.clientDetailList)
                    ? updateInstallmentStatusRequest(
                          state.clientDetailList,
                          action.payload
                      )
                    : {},
            };
        case DELETE_FUNDS_INSTALLMENT_FILE:
            return {
                ...state,
                clientDetailList: deleteFundsInstallmentFile(
                    state.clientDetailList,
                    action.payload
                ),
            };
        case GET_CRM_FUND_PENDING:
            return {
                ...state,
                pendingApprovalList: action.payload,
            };
        case CRM_REQUEST_LOGS:
            return {
                requestLogs: action.payload,
            };
        default:
            return state;
    }
};
